import React from "react";
import { TableModule } from "../../../components/home/TableModule";
import { useActualTurns } from "../../../hooks/turns/useActualTurns";
import { HeaderModule } from "../../../components/home/HeaderModule";

export const ActualTurns = ({ sede }) => {

    const { columns, total, actualTurns } = useActualTurns(sede);

    return (
        <>
            <HeaderModule
                icon={ <></> }
                title='En espera'
                component={ (
                    <div style={{ padding: '2px 5px', borderRadius: 6, background: '#00365F', display: 'flex', justifyContent: 'center', minWidth: 30, maxWidth: 50 }}>
                        <h3 style={{ color: '#fff' }}>{ total }</h3>
                    </div>
                ) }
            />

            <TableModule
                columns={ columns }
                rows={ actualTurns }
                styles={{ 
                    height: '40dvh',
                    background: '#fff',
                    borderRadius: 6,
                    marginTop: 10
                }}
            />
        </>
    );
}